import { createGetBlocksAPIStructure, createGetExports, } from './common';
export var createBlocksModel = function (config) {
    return {
        createController: function (createMethod) { return ({
            createMethod: createMethod,
            EXPORTS: {
                API: config.methods,
                EVENTS: config.events,
                PROPS: config.props,
            },
        }); },
        createPanel: function (_panelName, createPanelMethod) { return ({ createPanelMethod: createPanelMethod }); },
        _flatAPITypes: null,
        getExports: createGetExports(config),
        getBlocksAPIStructure: createGetBlocksAPIStructure(config),
    };
};
//# sourceMappingURL=widgetBuilder.js.map